<template>
    <div>
        <Drawer />
        <v-card-title>Lista de egresados</v-card-title>

        <v-container>
            <v-row>
                <v-data-table
                    :headers="headers"
                    :items="alumnos"
                    :search="search"
                    :loading="loading"
                    loading-text="Cargando egresados..."
                    item-key="id"
                    class="elevation-1"
                >
                <template v-slot:loading>
                    <v-container class="text-center py-10">
                    </v-container>
                </template>
                <v-spacer></v-spacer>
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar por Matrícula"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-select
                            v-model="selectedCiclo"
                            :items="ciclos"
                            item-text="desc_ciclo"
                            item-value="cve_ciclo"
                            label="Seleccionar Ciclo"
                            @change="getCiclo"
                            style="padding-top: 22px"
                        >
                        </v-select>
                    </v-toolbar>
                </template>
                <template v-slot:item.detalles="{ item }">
                    <v-btn class="ma-2" @click="sendStudent(item.Matrícula)">
                        <v-icon> mdi-account-details </v-icon>
                    </v-btn>
                </template>
                
                </v-data-table>
            </v-row>
            
        </v-container>
    </div>
</template>
<script>
    // import axios from "axios";
    import Drawer from "../Drawer/Drawer.vue";
    import FormacionInDataService from "../../services/FormacionInDataService";

    export default {
        name: "EgresadosList",

        components: {
            Drawer,
        },

        data() {
            return {
                search: "",
                alumnos: [],
                headers: [
                    { text: "Matrícula", value: "Matrícula" },
                    { text: "Nombres", value: "Nombres" },
                    { text: "Apellido paterno", value: "Apellido paterno" },
                    { text: "Apellido materno", value: "Apellido materno" },
                    { text: "Carrera", value: "Carrera" },
                    { text: "Ver detalles", align: "center", value: "detalles" },
                ],

                ciclos: [],
                selectedCiclo: null,
                loading: false,
            }
        },

        mounted() {
            console.log("Componente cargado");
            this.getCiclos();
        },

        methods: {
            getEgresados(ciclo = null){
                this.loading = true;

                FormacionInDataService.getEgresados(ciclo).then((response) => {
                    this.alumnos = response.data.egresados;
                }).catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                })
            },

            getCiclos(){
                FormacionInDataService.getCiclos().then((response) => {
                    this.ciclos = response.data;
                    if(this.ciclos.length > 0){
                        this.selectedCiclo = this.ciclos[0].cve_ciclo
                        this.getEgresados(this.selectedCiclo);
                    }
                }).catch((e) => {
                    console.log("Error al seleccionar ciclo: ", e);
                })
            },

            sendStudent(id) {
                this.$router.push({
                    name: "detallesEgresados",
                    params: {
                        id: id
                    },
                    query: {
                        ciclo: this.selectedCiclo
                    }
                });
            },

            getCiclo(){
                console.log("Ciclo seleccionado:", this.selectedCiclo); 
                this.getEgresados(this.selectedCiclo);
            },

        },
    }

</script>